<template>
  <div>
    <h1 style="text-align: center;">{{printObject.webinarDetails.Title}}</h1>
    <div>
      <strong>Presenter :</strong>
      {{printObject.webinarDetails.Presenter}}
    </div>
    <div>
      <strong>Date :</strong>
      {{ new Date(printObject.webinarDetails.Date.seconds * 1000 )}}
    </div>
    <div>
      <strong>Attendees :</strong>
      {{printObject.users.length}}
    </div>
    <div>
      <strong>
        Rating :
        <span v-html="getRatings()"></span>
      </strong>
    </div>
    <p>&nbsp;</p>
    <h3>KEY NOTES</h3>
    <div>
      <span v-html="printObject.webinarDetails.Content">{{printObject.webinarDetails.Content}}</span>
    </div>

    <h3>
      <strong>ATTENDEES</strong>
    </h3>
    <ol style="column-count: 3;">
      <li v-for="(user,index) in printObject.users" :key="index">
        <strong>{{user.name}}</strong>
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  data: () => {
    return {
      rating: 3,
      timeZone: "PST"
    };
  },
  props: {
    printObject: {
      type: Object
    }
  },
  mounted() {
    console.log(this.printObject);
  },
  methods: {
    getRatings() {
      var ratings = this.printObject.users
        .map(x => x.rating)
        .reduce((a, b) => a + b, 0);

      var ratingStar = [];
      let i = 1;
      for (i = 1; i <= 5; i++) {
        if (i <= ratings) {
          ratingStar.push("&#x2605; ");
        } else {
          ratingStar.push("&#9734; ");
        }
      }
      debugger;
      return ratingStar.toString().replace(/,/g, "");
    }
  }
};
</script>